import { LongTermOwnerDisplayValues } from '~/constants';
import { display } from '~/utils/displayValues/common';
import { Project } from '~/types/project';

export default function longTermOwner(project: Project) {
  return display(project?.longTermOwner ? LongTermOwnerDisplayValues[project.longTermOwner] : '');

}